import clsx from "clsx";
import React from "react";

interface LoaderProps {
	classes?: string;
	label?: string;
}

export function Loader({ classes, label = "Loading" }: LoaderProps) {
	return <span className={clsx("loader", classes)}>{label}</span>;
}
